import React from 'react';

var Provider = function (_a) {
    var _b = _a.altProviderName, altProviderName = _b === void 0 ? 'Pascal Gaming' : _b, providerLogo = _a.providerLogo;
    return (React.createElement("div", { className: 'logo-loading-wrapper' },
        React.createElement("img", { src: providerLogo, alt: altProviderName })));
};

export { Provider };
